var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGrade = function SvgGrade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FB3C6C",
    fillRule: "evenodd",
    d: "M14.468 9.692 12 4.358 9.532 9.692l-5.83.71 4.301 4.012-1.128 5.777L12 17.33l5.125 2.862-1.128-5.777 4.3-4.013-5.829-.709Zm-5.745-1.11-5.592.68a1 1 0 0 0-.561 1.724l4.128 3.852-1.083 5.546a1 1 0 0 0 1.469 1.065L12 18.704l4.916 2.745a1 1 0 0 0 1.47-1.065l-1.084-5.546 4.128-3.852a1 1 0 0 0-.561-1.724l-5.592-.68-2.37-5.12a1 1 0 0 0-1.815 0l-2.369 5.12Z",
    clipRule: "evenodd"
  })));
};
export default SvgGrade;